import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-14 md:py-20 px-4 bg-brand-cream text-brand-darkText relative" data-id="element-187">
      <div className="max-w-3xl mx-auto" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg md:text-xl leading-relaxed" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-6 text-center" data-id="element-190">
            ¿Sabes ese momento?
          </h2>

          <p data-id="element-191">
            Son las 3 de la tarde. Llevas todo el día comiendo bien. Desayunaste
            saludable, almorzaste lo que tenías planeado, tomaste tu agua...
          </p>

          <p className="font-semibold text-brand-medium text-2xl" data-id="element-192">
            Y de repente... El antojo llega.
          </p>

          <p data-id="element-193">
            No pide permiso. No te avisa. Solo aparece — ese hambre que no es
            hambre, esa necesidad de algo dulce, algo salado, algo crujiente...
            algo que te haga sentir bien por 5 minutos.
          </p>

          <p data-id="element-194">Y tú ya sabes lo que pasa después.</p>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-brand-light/20 my-10 italic text-brand-dark/80 space-y-4 relative" data-id="element-195">
            <div className="absolute top-0 left-8 -translate-y-1/2 text-6xl text-brand-gold/30 font-heading" data-id="element-196"></div>
            <p data-id="element-197">Abres el refri "solo a ver."</p>
            <p data-id="element-198">Revisas el cajón de la cocina "solo un momento."</p>
            <p data-id="element-199">
              Te dices "solo uno"... y de repente ya comiste la mitad del
              paquete.
            </p>
          </div>

          <p data-id="element-200">Después viene la culpa.</p>

          <div className="space-y-2 italic text-brand-medium" data-id="element-201">
            <p data-id="element-202">"¿Por qué no tengo fuerza de voluntad?"</p>
            <p data-id="element-203">"Mañana sí me porto bien."</p>
            <p data-id="element-204">"Ya arruiné el día."</p>
          </div>

          <p className="pt-6 font-medium" data-id="element-205">¿Te suena familiar?</p>

          <p data-id="element-206">
            Si la respuesta es sí, necesito que sepas algo importante antes de
            continuar:
          </p>

          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="text-center py-12" data-id="element-207">
            <h3 className="text-5xl md:text-7xl font-bold text-brand-gold font-heading tracking-tight" data-id="element-208">
              No es tu culpa.
            </h3>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}